<template>
  <div :class="$style.container">
    <p :class="$style.title">域名<span style="color: #01cbf3">优惠购</span></p>
    <p :class="$style.desc">
      数量有限，先到先得。更多域名优惠请联系售前或渠道经理确认
    </p>
  </div>
</template>

<script>
export default {
  name: "Background",
};
</script>

<style lang="scss" module scoped>
.container {
  width: 100%;
  height: rem(550);
  background-image: url("~@assets/image/domain_bg.png");
  background-size: cover;
  background-repeat: no-repeat;
  color: #fff;

  .title {
    width: rem(1200);
    margin: 0 auto;
    font-size: rem(48);
    font-family: FZLanTingHei-B-GBK;
    transform: translateY(rem(150));
  }

  .desc {
    width: rem(1200);
    margin: 0 auto;
    font-size: rem(20);
    font-family: PingFang SC;
    transform: translateY(rem(172));
  }
}
</style>